module.exports = __webpack_public_path__ + "img/leadershipinsea.5dc07dae.png";